const dictionary = {
  general: {
    logo: 'Sobrancelhas Design',
    abbreviationLogo: 'SD',
    copy: 'Copiar',
    notification: {
      error: 'No fue posible cargar los datos.',
      pageNotFound: 'Página no encontrada',
      forbidden: 'No tienes acceso a esta área'
    },
    action: 'Acción',
    addNew: 'Agregar',
    edit: 'Editar',
    alter: 'Modificar',
    note: 'Nota',
    update: 'Actualizar',
    back: 'Volver'
  },
  auth: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    connectionFail: 'No fue posible iniciar sesión, intenta más tarde.',
    pageTitle: 'Tienda del Franquiciado',
    welcome: 'Bienvenido a la Tienda del Franquiciado.',
    instruction: 'Haz clic en el botón de abajo para acceder.'
  },
  menu: {
    apollo: 'Nuevo Avant',
    reports: {
      title: 'Informes',
      billing: 'Informe de facturación'
    },
    midiaKit: {
      title: 'Kit de Medios',
      preInauguration: 'Preinauguración',
      inaugurationDay: 'Inauguración y día a día',
      gifts: 'Obsequios',
      campaignsPromotions: 'Campañas y Promociones',
      socialNetworks: 'Redes Sociales (Publicaciones)'
    },
    corporateMaterial: {
      title: 'Material Corporativo',
      openFranchisee: 'Antes de abrir tu franquicia',
      layoutFranchisee: 'Diseño de franquicia',
      operationFranchisee: 'Operación de franquicia',
      bulletin: 'Comunicados',
      technicalCenter: 'Centro Técnico'
    },
    videos: {
      title: 'Videos',
      eyebrows: 'Cejas',
      eyes: 'Ojos',
      face: 'Rostro',
      lips: 'Boca',
      oaccs: 'Accesorios'
    },
    store: {
      title: 'Tienda',
      kits: 'Inicio',
      cart: 'Carrito',
      orders: 'Mis pedidos',
      ordersSingle: 'Página del pedido',
      checkout: 'Finaliza tu compra',
      orderplaced: '',
      coupons: 'Créditos'
    },
    admin: {
      kits: 'Admin - Inicio',
      orders: 'Admin - Pedidos',
      promotions: 'Admin - Promociones',
      coupon: 'Admin - Créditos',
      financial: 'Admin - Finanzas',
      wallet: {
        title: 'Admin - Bonificación',
        points: 'Registrar Bonificación',
        bonus: 'Bonificación',
        products: 'Registro de productos'
      },
      store: {
        title: 'Listado de Kits',
        new: 'Creación de Kit',
        edit: 'Edición de Kit',
        orders: 'Pedidos',
        order: 'Página del pedido',
        promotions: 'Promociones',
        financial: 'Finanzas',
        movements: 'Registros de Bonificación',
        products: 'Productos',
        newPromotion: 'Agregar Promoción',
        updatePromotion: 'Editar Promoción'
      }
    },
  },
  coupon: {
    create: 'Crear crédito',
    generateRandomNumber: 'Generar código aleatorio',
    addNew: 'Agregar crédito',
    expired: 'Expirado',
    neverExpires: 'No expira',
    table: {
      code: 'Código',
      value: 'Valor',
      unit: 'Unidad',
      observation: 'Observación',
      expiresAt: 'Expira el',
      createdBy: 'Creado por',
      used: 'Utilizado',
      createdAt: 'Creado el',
      updatedAt: 'Actualizado el'
    },
    used: {
      yes: 'Utilizado',
      no: 'Disponible'
    },
    remove: {
      title: 'Eliminar crédito',
      confirm: '¿Seguro que deseas eliminar este crédito?',
      ok: 'Eliminar',
      cancel: 'Cancelar'
    },
    notification: {
      create: {
        success: 'Crédito creado con éxito.',
        error: 'No fue posible crear el crédito.'
      },
      remove: {
        success: 'Crédito eliminado con éxito.',
        error: 'No fue posible eliminar el crédito.'
      },
    },
    form: {
      title: 'Nuevo crédito',
      subtitle: 'Define el código, el valor, la unidad que podrá utilizarlo y, si quieres, una fecha de expiración y una observación interna.',
      placeholder: {
        code: 'Ej.: BIENVENIDO10',
        value: 'Informa el valor del descuento',
        unit: 'Selecciona una unidad',
        expiresAt: 'Sin fecha, el crédito no expira',
        observation: 'Opcional: motivo de la emisión del crédito'
      },
      message: {
        code: '¡Escribe un código!',
        value: '¡Escribe un valor!'
      }
    }
  },
  pageHeader: {
    search: 'Buscar',
    filter: 'Filtrar'
  },
  home: {
    title: 'Página de inicio'
  },
  avant: {
    logo: 'Avant',
    new: {
      title: 'Nuevo Avant',
      description: 'Este es el nuevo Avant',
    },
    download: 'Descargar',
    license: 'Licencia',
    copy: '¡Licencia copiada!',
    notification: {
      noLicense: {
        title: 'Licencias disponibles',
        text: 'No encontramos ninguna licencia disponible para tu usuario. Asegúrate de haber iniciado sesión con el correo electrónico de la unidad e intenta nuevamente más tarde.\r\n\r\nSi tienes dudas, comunícate con el Soporte por medio del correo <a href="mailto:novo_avant@gsd.com.br">novo_avant@gsd.com.br</a>.',
      },
    },
  },
  download: {
    description: 'Descripción',
    files: 'Archivos',
    copy: '¡Enlace copiado!',
  },
  reports: {
    filters: {
      states: 'Todos los estados',
      button: 'Filtrar',
    },
    charts: {
      typeServiceQuantity: 'Tipo de Servicio (Cantidad)',
      typeServiceValue: 'Tipo de Servicio (Valor)',
      sdMakeUpQuantity: 'SD MAKE•UP (Cantidad)',
      sdMakeUpValue: 'SD MAKE•UP (Valor)',
      utilizationCombo: 'Aprovechamiento: Combo (Cantidad)',
      utilizationEpilation: 'Aprovechamiento: Depilación (Cantidad)',
      utilizationSdRelax: 'Aprovechamiento: SD Relax (Cantidad)',
      utilizationSdMakeUp: 'Aprovechamiento: SD MAKE•UP (Cantidad)',
    },
    table: {
      title: 'Resumen de servicios',
      quantity: 'Cantidad',
      value: 'Valor',
    },
  },
  store: {
    purchaseLimit: {
      available: 'Disponible a plazos: {value}',
      exceeded: 'Por encima del límite a plazos: solo al contado',
      limit: 'Límite para compras a plazos {range}: {value}',
      used: 'Ya comprado a plazos {range}: {value}',
      inCart: 'En el carrito: {value}',
      cashNotice: 'Las compras al contado no tienen límite.',
      range: {
        month: 'este mes',
        period: 'del {from} al {to}',
        since: 'a partir del {from}',
      },
      shippingNotice: 'El envío y el seguro no cuentan en el límite.',
    },
    add: 'Comprar',
    remove: 'Eliminar',
    view: 'Visualizar',
    unavailable: 'No disponible',
    addNew: 'Agregar',
    minPrice: 'desde',
    notifyAvailable: 'Avísame cuando esté disponible',
    types: {
      1: 'Insumo',
      2: 'Maquillaje',
    },
    emptyData: 'No se encontró ningún kit',
    notification: {
      list: {
        error: 'No se pudo actualizar el kit.',
      },
      notifyMe: {
        success: 'Se te avisará cuando este producto esté disponible.',
        error: 'No se pudo programar la notificación',
      }
    },
    search: {
      kits: 'Filtrar por kit',
      products: 'Buscar por producto',
    },
    blocked: {
      type: 'El carrito ya contiene kits de “{type}”. Solo se pueden agregar kits del mismo tipo',
      origin: 'El carrito ya contiene kits provenientes de “{origin}”. Solo se pueden agregar kits del mismo origen',
      stock: 'Agotado',
      exclusive: 'Los kits exclusivos deben ser únicos en el carrito',
      promotion: 'Los kits promocionales solo se pueden agregar con otros kits promocionales',
      orderProcessing: 'Hay un pedido en proceso',
    },
    alert: {
      title: '¡Atención!',
      message: 'Se encontró un pendiente en el registro de su unidad.<br>En caso de dudas, por favor contacte al departamento financiero a través del correo <a href="mailto:{email}">{email}</a>.',
      retry: 'Intentar nuevamente',
      email: 'financiero@gsd.com.br',
    },
    notFound: 'No se encontró ningún producto para el filtro seleccionado.',
    points: {
      calculation: '| de {value} a {previousBalance}',
      model: {
        empty: 'No existe ninguna transacción',
        title: 'Movimientos',
      },
      status: {
        received: 'Recibido',
        exchange: 'Cambio',
        reversal: 'Reversión',
        canceled: 'Cancelado',
        pending: 'Pendiente',
        deposit: 'Depósito',
        expired: 'Expirado',
      },
    },
  },
  orders: {
    order: 'ID de tienda',
    title: 'Mis pedidos',
    course: 'Capacitación',
    kit: 'Kit',
    trackingNumber: 'Número de rastreo',
    noTrackingNumber: 'No disponible',
    shippingMethod: 'Envío',
    quantity: 'Cantidad',
    comments: 'Observaciones',
    price: 'Valor',
    discount: 'Descuento',
    subtotal: 'Subtotal',
    total: 'Total',
    unit: 'Unidad',
    paymentInfo: 'Pago',
    productsSubtotal: 'Productos',
    insurance: 'Seguro',
    coupon: 'Crédito',
    promotion: 'Promoción',
    goBack: 'Regresar',
    message: 'Informamos que, debido a la actual crisis operativa enfrentada por Correos, las entregas realizadas por este canal pueden sufrir retrasos significativos, afectando los plazos previstos al momento de la compra.',
    table: {
      title: 'Lista de productos',
      orderedAt: 'Fecha del pedido',
      updatedAt: 'Fecha de actualización',
      order: '#',
      status: 'Estado',
      externalId: 'ID del pedido',
      total: 'Total',
      subtotal: 'Subtotal',
      product: 'Nombre',
      items: 'Ítems',
      unit: 'Unidad',
      distribution: 'CD',
      nf: 'NF',
      discount: 'Descuento',
      goldPoints: 'Puntos Gold',
      silverPoints: 'Puntos Silver',
      erpId: 'ID del pedido'
    },
    modal: {
      title: 'Aviso',
      continue: 'Continuar',
      cancel: 'Cancelar',
      message: '¡Ya tienes productos en el carrito! Al comprar nuevamente, todos los ítems actuales serán eliminados. ¿Deseas continuar?'
    },
    rePurchase: 'Comprar nuevamente',
    cancelOrder: 'Cancelar pedido',
    confirmCancel: 'Haz clic para confirmar',
    download: 'Descargar etiquetas',
    unavailableDownload: 'Etiquetas no disponibles',
    noBarcode: 'El pedido no tiene etiquetas',
    notification: {
      error: 'No se pudo cargar el pedido',
    },
    alert: {
      title: 'Pre-reserva',
      message: 'Necesitas completar la información de todos los participantes para confirmar tu reserva.',
    },
    search: {
      labels: {
        title: 'Parámetros de búsqueda:',
        button: 'Buscar',
        order: 'Pedido',
        unit: 'Unidad',
        dateRange: 'Periodo',
        status: 'Estado',
        distribution: 'Centro de distribución',
        erpId: 'ID del pedido'
      },
      order: 'Buscar por Nº de pedido',
      unit: 'Buscar por unidad',
      distribution: 'Todos los centros',
      erpId: 'Buscar por Nº de FoccoErp'
    },
    warning: {
      title: 'Aviso',
      message: 'Este pedido aún no ha sido finalizado.'
    }
  },
  billing: {
    title: 'Información de Pago',
    status: {
      expired: 'Atrasado',
      paid: 'Pagado',
      open: 'Abierto',
      empty: '-',
    },
    table: {
      installment: 'Cuota',
      expiration: 'Vencimiento',
      status: 'Estado',
      price: 'Valor',
      download: 'Descargar',
      availableDownload: 'Descargar boleto',
      unavailableDownload: 'Disponible pronto',
    },
  },
  status: {
    error: 'Error',
    canceled: 'Cancelado',
    cart: 'Carrito',
    processing: 'Procesando...',
    payment_pending: 'Esperando pago',
    paid: 'Pagado',
    preparing: 'Preparando...',
    prepared: 'Preparado',
    sent: 'Enviado',
    avant_received: 'Recibido en Avant',
  },
  dateRanges: {
    today: 'Hoy',
    thisMonth: 'Este mes',
    lastMonth: 'Mes pasado',
    sevenDaysAgo: 'Últimos 7 días',
    thirtyDaysAgo: 'Últimos 30 días',
  },
  checkout: {
    title: 'Resumen del Pedido',
    update: 'Actualizar',
    firstIntroMessage: '¿Listo para hacer tu pedido?',
    secondIntroMessage: 'Vamos a verificar que todo esté correcto.',
    titleCarriers: 'Opciones de envío',
    titlePaymentMethods: 'Opciones de pago',
    commentsLabel: 'Observaciones',
    shippinfInfoLabel: 'Información para recoger en el lugar',
    purchase: 'Finalizar compra',
    messageAlertGreeting: 'Estimado(a) Cliente,',
    messageAlert: 'Informamos que, debido al actual escenario logístico en Brasil, las entregas realizadas pueden sufrir retrasos significativos, afectando los plazos previstos al momento de la compra. La entrega es realizada por empresas terceras, fuera de la gestión directa de la distribuidora. Nuestro compromiso es garantizar la expedición ágil y segura de todos los pedidos. Sin embargo, eventuales retrasos derivados de la opción logística escogida no son responsabilidad de la distribuidora.',
    orderReview: {
      subtotal: 'Subtotal',
      insurance: 'Seguro',
      shipping: 'Envío',
      discount: 'Descuento: {discount}',
      totalDiscount: 'Total de descuentos',
      promotion: 'Promoción: {title}',
      promotionWithPercentage: 'Promoción: {title} ({percentage}%)',
      otherDiscounts: 'Otros descuentos',
      coupon: 'Crédito {code}',
      removeCoupon: 'Eliminar crédito',
      total: 'Total a pagar',
    },
    openMonday: '¿Está abierto los lunes?',
    coupon: {
      label: 'Crédito de descuento',
      placeholder: 'Escribe el código del crédito',
      apply: 'Aplicar',
      applied: 'Crédito {code} aplicado. Descuento de {value} en el valor del pedido.',
      notification: {
        apply: {
          success: 'Crédito aplicado con éxito.',
          error: 'No fue posible aplicar el crédito.'
        },
        remove: {
          success: 'Crédito eliminado con éxito.',
          error: 'No fue posible eliminar el crédito.'
        }
      }
    },
    notice: 'Verifica que las opciones de envío y pago estén seleccionadas para finalizar la compra.',
    shippingInfoNotice: 'Cuando eliges recoger en el lugar, necesitas proporcionarnos información importante: Razón Social y NIT de la transportadora.',
    deliveryAddress: 'Dirección de entrega:',
    shippingLoading: 'Calculando envío',
    notification: {
      success: 'Pedido finalizado con éxito',
      error: 'No fue posible finalizar el pedido.',
    },
    requiredBaseKit: 'Incluir Kit: {kitRequired}',
    purchaseLimitExceeded: 'El valor de los productos supera el saldo de compra a plazos de su unidad {range} ({available} de {limit}). Para finalizar, elija pago al contado.',
    basicProductsKit: '¡Básico Productos!',
    monthlyInstallments: 'Opción',
    orderPlaced: {
      title: '¡Gracias!',
      subtitle: 'Pedido realizado con éxito.',
      received: 'Hemos recibido la información de tu pedido. Los boletos están siendo generados y estarán disponibles pronto en la tienda. Revisa tu correo electrónico.',
      notice: '',
      continueShopping: 'Continuar comprando',
      viewOrders: 'Ver pedidos',
    },
  },
  admin: {
    store: {
      notification: {
        create: {
          success: 'Kit creado con éxito.',
          error: 'No fue posible crear el kit.',
        },
        update: {
          success: 'Kit actualizado con éxito.',
          error: 'No fue posible actualizar el kit.',
        },
        labels: {
          success: 'Descarga completada.',
          error: 'No fue posible descargar las etiquetas.',
        },
        order: {
          paid: 'Pedido marcado como pagado con éxito',
          cancel: 'Pedido cancelado con éxito',
          errorCancel: 'No fue posible cancelar el pedido',
          nf: 'Factura guardada con éxito',
          errorNf: 'No fue posible guardar la factura',
        },
        kitMandatory: {
          success: 'Actualizado con éxito.',
          error: 'No fue posible actualizar.',
        }
      },
      active: 'Activo',
      inactive: 'Inactivo',
      status: 'Estado',
      balanceInsufficient: 'Stock insuficiente',
      balance: 'En stock',
      create: {
        form: {
          button: 'Guardar',
          name: 'Nombre del kit',
          image: 'Imagen del kit',
          price: 'Precio mínimo',
          type: 'Tipo de kit',
          types: {
            makeup: 'Maquillaje',
            input: 'Insumo',
          },
          custom: 'Personalizable',
          active: 'Activo',
          discount: 'Descuento (%)',
          isExclusive: 'Exclusivo',
          isGloballyAvailable: 'Disponible para todos',
          isBasicKitRequired: 'Kit obligatorio',
          fixedItemsQuantity: 'Cantidad fija de artículos',
          units: {
            list: 'Unidades',
            search: 'Buscar unidades',
            period: 'Período',
            empty: 'Ninguna unidad agregada',
          },
          regions: {
            search: 'Buscar regiones',
          },
          products: {
            list: 'Productos',
            search: 'Buscar productos',
            exception: '*Seleccione el tipo de kit antes de agregar productos',
            empty: 'Ningún producto agregado',
            min: 'Cantidad mínima',
            max: 'Cantidad máxima',
          },
        },
      },
    },
  },
  cart: {
    title: 'Carrito de compras',
    table: {
      name: 'Nombre',
      quantity: 'Cantidad',
      unitValue: 'Precio unitario',
      subtotal: 'Subtotal',
      total: 'Total',
      button: 'Siguiente',
      continueShopping: 'Continuar comprando',
      discount: 'Descuento',
      goldPoints: 'Puntos de oro',
      silverPoints: 'Puntos de plata',
    },
    info: {
      title: 'Vencimiento del boleto',
      description: 'No se aceptarán pagos de boletos después de la fecha de vencimiento. Por favor, preste atención a la fecha impresa en el boleto.',
    },
    notification: {
      remove: {
        error: 'No fue posible remover el kit del carrito',
      },
      add: {
        error: 'No fue posible agregar el kit al carrito',
        product: 'Por favor, revise los productos indicados a continuación.',
      },
      update: {
        error: 'No fue posible actualizar el kit del carrito',
      },
    },
  },
  table: {
    of: 'de',
    items: 'artículos',
    perPage: ' por página',
    columnSearch: {
      search: 'Buscar',
      reset: 'Limpiar',
    },
  },
  modal: {
    kitProduct: {
      purchaseAvailable: 'Disponible a plazos',
      purchaseLimitExceeded: 'El valor del kit supera el saldo disponible a plazos. Puede agregarlo al carrito, pero el pedido solo podrá pagarse al contado.',
      cashOnly: 'Solo al contado',
      minimum: 'Precio mínimo',
      kitValue: 'Valor del kit',
      addToCart: 'Agregar al carrito',
      updateCart: 'Actualizar carrito',
      pointsAvailable: 'Puntos disponibles',
      fixedItemsQuantity: 'Productos necesarios',
    },
  },
  wallets: {
    addNew: 'Agregar',
    table: {
      wallet: 'Cartera',
      description: 'Descripción',
      unit: 'Unidad',
      type: 'Tipo',
      points: 'Puntos',
      noAccess: 'Lo sentimos, el usuario no tiene permiso para acceder a esta página.',
      empty: 'Sin datos',
      name: 'Nombre',
      isActive: '¿Activo?',
      product: 'Producto',
      reward: 'Premio',
      rewardDescription: 'Bonificación de puntos del tipo {type}',
      quantity: 'Cantidad',
      dateCreate: 'Fecha de creación',
    },
    titleModal: 'Depositar puntos',
    form: {
      title: 'Título',
      product: 'Producto',
      productName: 'Nombre del producto',
      unit: 'Unidad',
      type: 'Tipo',
      quantity: 'Cantidad',
      points: 'Puntos',
      description: 'Descripción',
      button: 'Enviar',
      addNew: 'Agregar',
      message: {
        unit: '¡Es obligatorio seleccionar una unidad!',
        type: '¡Es obligatorio seleccionar un tipo de cartera!',
        product: '¡Es obligatorio seleccionar un producto!',
        productName: '¡Es obligatorio informar el nombre del producto!',
        tooltip: 'Seleccione el producto disponible para canjear puntos, habilitado por FOCCO.',
        points: '¡Debe tener al menos un punto!',
        quantity: '¡Debe tener al menos una cantidad!',
        description: '¡Es obligatorio tener una descripción sobre este depósito!',
      },
      placeholder: {
        unit: 'Seleccione una unidad',
        product: 'Seleccione un producto',
        type: 'Seleccione el tipo de cartera',
      },
    },
    notification: {
      error: 'No se pudieron cargar los puntos.',
      create: {
        success: 'Depósito realizado con éxito.',
        error: 'No se pudo realizar el depósito.',
      },
      product: {
        create: {
          success: 'Producto registrado con éxito.',
          error: 'Error al registrar el producto.',
        },
        update: {
          success: 'Producto actualizado con éxito.',
          error: 'Error al actualizar el producto.',
        },
      }
    },
  },
  promotions: {
    addNew: 'Agregar',
    save: 'Guardar',
    table: {
      promotion: 'Promoción',
      discount: 'Descuento',
      startsAt: 'Inicio',
      finishesAt: 'Fin',
    },
    form: {
      title: 'Título',
      discount: 'Descuento',
      startsAt: 'Inicio',
      finishesAt: 'Fin',
      button: 'Enviar',
      period: 'Período',
      active: 'Activo',
      description: 'Descripción',
      addNew: 'Agregar',
      rules: 'Reglas',
      discountIsVariable: 'Descuento variable',
    },
    rules: {
      type: 'Tipo',
      operator: 'Operador',
      value: 'Valor',
    },
    types: {
      kits: 'Kits',
      payments: 'Formas de pago',
      shipping: 'Envío',
      subtotal: 'Subtotal',
      cart: 'Carrito',
      unit: 'Unidad',
      region: 'Región',
      purchasedKit: 'Kit ya comprado por la unidad',
      purchasedKitPayment: 'Forma de pago del kit comprado',
    },
    operators: {
      equalTo: 'Igual a (==)',
      lessThan: 'Menor que (<)',
      lessThanOrEqual: 'Menor o igual a (<=)',
      greaterThan: 'Mayor que (>)',
      greaterThanOrEqual: 'Mayor o igual a (>=)',
      contain: 'Contiene',
      notContain: 'No contiene',
    },
    notification: {
      create: {
        success: 'Promoción creada con éxito.',
        error: 'No se pudo crear la promoción.',
      },
      update: {
        success: 'Promoción actualizada con éxito.',
        error: 'No se pudo actualizar la promoción.',
      },
    },
  },
  financial: {
    addDefaulter: 'Agregar moroso',
    table: {
      unit: 'Unidad',
      editUser: 'Usuario editado',
      createdAt: 'Creado',
      updatedAt: 'Actualizado',
      kitMandatory: 'Kit obligatorio liberado',
      jumpCommand: 'Ignorar comando Bloqueio'
    },
    pleaseSelectedUnit: '¡Por favor! Seleccione la unidad.',
    selectedUnit: 'Seleccione la unidad',
    createDefaulter: 'Agregar moroso',
    editDefaulter: 'Editar moroso',
    isActiveDefaulter: {
      true: 'Moroso',
      false: 'Liberado',
    },
    addNoteCustomer: 'Agregue una nota de este cliente',
    addNote: 'Agregar una nota',
    viewNoteFrom: 'Ver nota de',
    tabs: {
      defaulters: 'Morosos',
      purchaseLimit: 'Límite de compra',
      ordersProcessing: 'Pedidos en procesamiento',
    },
    ordersProcessing: {
      orders: 'En procesamiento',
      oldest: 'Más antiguo',
      kitTypes: 'Tipos',
      total: 'Valor',
      order: 'Pedido',
      orderedAt: 'Realizado',
      empty: 'Ninguna unidad con pedido en procesamiento',
      filter: {
        processing: 'Con pedido en procesamiento',
        all: 'Todas las unidades',
      },
      status: {
        title: 'Situación',
        none: 'Sin pedido',
        blocked: 'Bloqueada',
        released: 'Liberada',
      },
      stats: {
        units: 'Unidades con pedido en procesamiento',
        orders: 'Pedidos en procesamiento',
        released: 'Unidades liberadas para comprar',
      },
    },
    allowOrderWhileProcessing: {
      title: 'Comprar con pedido en procesamiento',
      help: 'Cuando está liberado, la unidad puede hacer nuevos pedidos aunque tenga un pedido del mismo tipo en estado Procesando.',
      released: 'Liberado',
      blocked: 'Bloqueado',
      confirm: '¿Liberar la unidad {unit} para comprar aunque tenga un pedido en procesamiento?',
      processing: 'Pedido en procesamiento',
      processingBlocked: 'La unidad tiene un pedido en procesamiento y está bloqueada para comprar kits del mismo tipo.',
      processingReleased: 'La unidad tiene un pedido en procesamiento, pero está liberada para seguir comprando.',
      notification: {
        success: 'Permiso actualizado con éxito.',
        error: 'No fue posible actualizar el permiso.',
      },
    },
    purchaseLimit: {
      description: 'Valor máximo de productos (con descuentos, sin envío ni seguro) que cada unidad puede comprar a plazos. Mensual: suma los pedidos a plazos del mes en curso y el saldo se reinicia el día 1 de cada mes. Por período: suma los pedidos a plazos realizados entre las fechas elegidas (fecha final opcional); fuera del período las compras a plazos no tienen límite. Los pedidos pagados siguen contando; los cancelados no. Las compras al contado no tienen límite. Déjelo vacío para no limitar.',
      perMonth: 'Mensual, solo a plazos',
      type: {
        monthly: 'Mensual',
        period: 'Por período',
      },
      period: {
        from: 'De',
        to: 'hasta',
        startPlaceholder: 'Fecha inicial',
        endPlaceholder: 'Sin fecha final',
        range: 'Del {from} al {to}',
        since: 'A partir del {from}',
        startRequired: 'Indique la fecha inicial del período para guardar',
      },
      usage: {
        title: 'Uso',
        used: '{used} de {limit}',
        available: 'Disponible: {value}',
        help: 'Suma de los pedidos a plazos realizados en {month}. Los pedidos cancelados liberan el saldo; el saldo se reinicia al inicio de cada mes.',
        helpPeriod: 'Suma de los pedidos a plazos realizados en el período ({period}). Los pedidos cancelados liberan el saldo.',
        inactiveHelp: 'Fuera del período las compras a plazos no tienen límite.',
        startsAt: 'Empieza el {date}',
        endedAt: 'Terminó el {date}',
      },
      limit: 'Límite a plazos',
      noLimit: 'Sin límite',
      placeholder: 'Sin límite',
      save: 'Guardar',
      clear: 'Quitar límite',
      updatedBy: 'Modificado por',
      updatedAt: 'Modificado en',
      current: 'Límite actual',
      unsaved: 'Cambio no guardado — Enter para guardar, Esc para cancelar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      confirmZero: 'Con límite cero, la unidad {unit} solo podrá comprar al contado. ¿Confirmar?',
      confirmClear: '¿Quitar el límite a plazos de la unidad {unit}? Podrá hacer pedidos a plazos de cualquier valor.',
      notification: {
        success: 'Límite de compra actualizado con éxito.',
        error: 'No fue posible actualizar el límite de compra.',
      },
    },
    notification: {
      create: {
        success: 'Moroso agregado con éxito.',
      },
    },
  },
}

export default {
  locale: 'es',
  label: 'Espanhol',
  country: 'GT',
  currency: 'GTQ',
  dictionary,
}
